<template>
	<Alert type="danger">
		<template #icon>
			<IconCancel size="lg" />
		</template>
		<slot />
	</Alert>
</template>

<script>
import Alert from './Alert.vue'
import IconCancel from '../icon/IconCancel.vue'
export default {
	components: {
		Alert,
		IconCancel
	}
}
</script>
